import React from "react";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import GroupsIcon from "@mui/icons-material/Groups";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import PolicyIcon from "@mui/icons-material/Policy";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CampaignIcon from "@mui/icons-material/Campaign";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function KnowledgeManagementPage() {
  const categories = [
    {
      icon: <TrendingUpIcon className="text-5xl text-orange-600" />,
      title: "Program Reports",
      description: "Annual reports, program summaries, and more",
      route: "/knowledgehub",
    },
    {
      icon: <AssignmentTurnedInIcon className="text-5xl text-orange-600" />,
      title: "Program Assessments",
      description: "Pre & post evaluations, feedback forms",
      route: "/program",
    },
    {
      icon: <GroupsIcon className="text-5xl text-orange-600" />,
      title: "Stakeholder Insights",
      description: "FGDs, supervisions, partner surveys",
      route: "/stakeholderinsights",
    },
    {
      icon: <QueryStatsIcon className="text-5xl text-orange-600" />,
      title: "Data & Analytics",
      description: "Performance metrics, trend analysis",
      route: "/dataanalytics",
    },
    {
      icon: <PolicyIcon className="text-5xl text-orange-600" />,
      title: "Policy & Strategy",
      description: "Policy briefs, strategic frameworks",
      route: "/policy",
    },
    {
      icon: <MenuBookIcon className="text-5xl text-orange-600" />,
      title: "Training Materials",
      description: "Trainer guides, session outlines, manuals",
      route: "/trainingmaterial",
    },
    {
      icon: <CampaignIcon className="text-5xl text-orange-600" />,
      title: "Publications",
      description: "Promotional materials, flyers, event brochures",
      route: "/brochure",
    },
  ];

//   return (
//     <div className="min-h-screen bg-gray-100 px-6 py-12 font-sans">
//       {/* CSS to remove zigzag on small screens */}
//       <style>{`
//         @media (max-width: 630px) {
//           .zigzag {
//             transform: translateY(0) !important;
//           }
//         }
//       `}</style>

//       {/* <header className="text-center mb-10">
//         <h2 className="text-4xl font-bold text-orange-600 mb-4">Knowledge Hub</h2>
//         <hr
//           className="w-1/6 mx-auto"
//           style={{
//             border: "none",
//             borderTop: "2px dashed",
//             borderImage: "linear-gradient(to right, #ffcccc, #fa5d15) 1",
//             height: "0",
//           }}
//         />
//         <div className="text-center mb-10">
//           <h2 className="text-3xl font-semibold text-gray-800 mb-2">
//             Knowledge Management Documents
//           </h2>
//           <p className="text-gray-600">
//             Explore our collection of impact reports, training assessments,
//             satisfaction surveys, and more.
//           </p>
//         </div>
//       </header> */}

//       {/* Large screen layout: flex + zigzag */}
//       {/* <div className="hidden sm:flex flex-wrap gap-6 px-4 pb-12">
//         {categories.map((item, index) => (
//           <motion.div
//             key={index}
//             className="zigzag"
//             style={{
//               transform: `translateY(${index % 2 === 0 ? "0px" : "60px"})`,
//             }}
//           >
//             <CategoryCard
//               icon={item.icon}
//               title={item.title}
//               description={item.description}
//               route={item.route}
//               delay={index * 0.1}
//             />
//           </motion.div>
//         ))}
//       </div> */}

//       {/* Small screen layout: responsive grid */}
//       {/* <div className="grid grid-cols-1 gap-4 px-4 pb-10 sm:hidden">
//         {categories.map((item, index) => (
//           <motion.div key={index}>
//             <CategoryCard
//               icon={item.icon}
//               title={item.title}
//               description={item.description}
//               route={item.route}
//               delay={index * 0.1}
//             />
//           </motion.div>
//         ))}
//       </div> */}
//     </div>
//   );
}

function CategoryCard({ icon, title, description, route, delay }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (route) navigate(route);
  };

  return (
    <motion.div
      onClick={handleClick}
      initial={{ opacity: 0, y: -100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ scale: 1.09 }}
      whileTap={{ scale: 0.99 }}
      className="w-full sm:w-[159px] h-[200px] bg-white border border-gray-200 rounded-xl shadow-md flex flex-col items-center text-center p-4 cursor-pointer hover:bg-gray-50 transition"
    >
      <div className="mb-2">{icon}</div>
      <h3 className="text-md font-semibold text-gray-800 mb-1">{title}</h3>
      <p className="text-sm text-gray-600">{description}</p>
    </motion.div>
  );
}
